export default {
    name: 'proposal',
    documents: 'documents',
    downloadLink: 'downloadLink',
    fileLocation: 'fileLocation',
    orderedProducts: 'orderedProducts',
    selectedProducts: 'selectedProducts',
    submittalReady: 'submittalReady',
};
